export default __webpack_public_path__ + "static/media/factory.0ad74e5c.png";